import { Logo } from "./Logo";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Menu, X, MapPin, Heart, Plus, Shield, LogOut, User } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const isActive = (p) => location.pathname === p;
  const navItem = (to, label) => (
    <Link
      to={to}
      data-testid={`nav-${label.toLowerCase().replace(/\s/g, "-")}`}
      onClick={() => setOpen(false)}
      className={`transition-colors duration-200 hover:text-white ${isActive(to) ? "text-wyd-accent" : "text-wyd-muted"}`}
    >
      {label}
    </Link>
  );

  return (
    <header className="fixed top-0 left-0 right-0 z-[1000] glass">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="text-2xl">
          <Logo />
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
          {navItem("/", "Esplora")}
          {navItem("/mappa", "Mappa")}
          {navItem("/perche-wyd", "Perché WYD")}
          {navItem("/proponi", "Proponi Evento")}
          {user?.is_admin && navItem("/admin", "Admin")}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link to="/profilo" data-testid="nav-profile" className="flex items-center gap-2 text-sm text-wyd-muted hover:text-white transition-colors duration-200">
                <User size={16} /> {user.name}
              </Link>
              <button data-testid="nav-logout" onClick={() => { logout(); navigate("/"); }}
                className="text-wyd-muted hover:text-wyd-accent transition-colors duration-200" aria-label="Esci">
                <LogOut size={18} />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm text-wyd-muted hover:text-white transition-colors duration-200">Accedi</Link>
              <Link to="/register" data-testid="nav-register"
                className="text-sm font-semibold px-5 py-2 rounded-full bg-wyd-accent text-wyd-bg hover:glow-magenta transition-shadow duration-300">
                Registrati
              </Link>
            </>
          )}
        </div>

        <button data-testid="nav-mobile-toggle" className="md:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-white/10 px-5 py-5 flex flex-col gap-4 text-base">
          {navItem("/", "Esplora")}
          {navItem("/mappa", "Mappa")}
          {navItem("/perche-wyd", "Perché WYD")}
          {navItem("/proponi", "Proponi Evento")}
          {user?.is_admin && navItem("/admin", "Admin")}
          <div className="h-px bg-white/10" />
          {user ? (
            <>
              <Link to="/profilo" onClick={() => setOpen(false)} className="text-wyd-muted flex items-center gap-2"><Heart size={16} /> Il mio profilo</Link>
              <button data-testid="nav-mobile-logout" onClick={() => { logout(); setOpen(false); navigate("/"); }} className="text-left text-wyd-accent">Esci</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="text-wyd-muted">Accedi</Link>
              <Link to="/register" onClick={() => setOpen(false)} className="text-wyd-accent font-semibold">Registrati</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
};
